import * as Yup from 'yup';
import { Locale } from '@synergy/models';

export const getValidationSchema = (selectedLanguage: Locale) =>
    Yup.object().shape({
        title: Yup.object().shape({
            [selectedLanguage]: Yup.string().required('app.error.required'),
        }),
        text: Yup.object().shape({
            [selectedLanguage]: Yup.string().required('app.error.required'),
        }),
        path: Yup.string().required('app.error.required'),
    });
